import _ from 'lodash'

export function checkVueObserver(obj: any) {
  if (hasVueObserver(obj, true)) {
    console.error('Coding error: Vue observer property found in object', obj)
    throw new Error('Coding error: Vue observer property found in object')
  }

  return obj
}

export function hasVueObserver(obj: any, deep: boolean) {

  if ('__ob__' in obj) {
    return true
  }
  
  if (!deep) { return false }

  return deepCheck(obj)
  
  function deepCheck(obj: any) {

    let found = false
    
    _.forOwn(obj, (value) => {

      if (found) { return }
      
      const isObject = _.isPlainObject(value)
      const isArray = _.isArray(value)

      if (isObject && deepCheck(value)) {
        found = true
      }

      if (!found && (isObject || isArray)) {
        if ('__ob__' in value) {
          found = true
        }
      }
    })

    return found
  }  
}

export function cloneRemovingVueObserver(obj: any) {
  if (!obj) { return obj }
  return _.cloneDeep(obj)
//  return JSON.parse(JSON.stringify(obj))
}
